import { changeItem } from '../lib/cart';

export default (node) => {
  /**
   * Data + elements
   */
  const cartContent = node.querySelector('[data-cart-content]');
  const mainCartContentLoading = node.querySelector('[data-main-cart-content-loading]');

  /**
   * Functions
   */
  const checkoutChattersHandler = () => {
    // scroll to checkout_address with an offset of 100px
    const checkoutChatters = node.querySelector(
      '[data-checkout-chatters]'
    );
    const checkoutAddress = node.querySelector('[data-customer-addresses]');

    checkoutAddress.classList.remove('hidden');
    const elementTop = checkoutAddress.getBoundingClientRect().top + window.pageYOffset;
    const targetPosition = elementTop - 100;

    const placeOrderButton = node.querySelector('[data-place-order-chatters]');

    placeOrderButton.classList.remove('hidden');

    window.scrollTo({
      top: targetPosition,
      behavior: 'smooth' // use 'auto' for instant scroll
    });
  };

  const attachEventListener = () => {
    const allItems = node.querySelectorAll('[data-cart-item]');
    allItems.forEach((item) => {
      const itemIncrease = item.querySelector('[data-cart-quantity-increase]');
      if (itemIncrease) {
        itemIncrease.addEventListener('click', () => {
          updateQuantityCartInfo(
            item.dataset.lineItemKey,
            Number(item.dataset.lineCurrentQuantity) + 1
          );
        });
      }
      const itemDecrease = item.querySelector('[data-cart-quantity-decrease]');
      if (itemDecrease) {
        itemDecrease.addEventListener('click', () => {
          updateQuantityCartInfo(
            item.dataset.lineItemKey,
            Number(item.dataset.lineCurrentQuantity) - 1
          );
        });
      }

      const itemRemove = item.querySelector('[data-cart-remove-item]');
      if (itemRemove) {
        itemRemove.addEventListener('click', () => {
          updateQuantityCartInfo(item.dataset.lineItemKey, 0);
        });
      }
    });

    const checkoutChatters = node.querySelector(
      '[data-checkout-chatters]'
    );
    if (checkoutChatters) {
      checkoutChatters.addEventListener('click', checkoutChattersHandler);
    }

    const placeOrderChatters = node.querySelector(
      '[data-place-order-chatters]'
    );
    if (placeOrderChatters) {
      placeOrderChatters.addEventListener('click', placeOrderChattersHandler);
    }

  };

  const placeOrderChattersHandler = async () => {
    // disable the button
    const errorMessage = node.querySelector('[data-error-message]');
    const thankYouForYourOrder = document.querySelector('[data-thank-you-for-your-order]');

    const placeOrderButton = node.querySelector('[data-place-order-chatters]');
    const placeOrderChatters = node.querySelector(
      '[data-place-order-chatters]'
    );
    placeOrderChatters.disabled = true;

    const loaderChatters = node.querySelector('[data-loader-chatters]');
    loaderChatters.classList.remove('hidden');

    // get the form data
    const customerEmail = node.dataset.customerEmail;
    const currency = node.dataset.shopCurrency;
    const isChattersHQCustomer = node.dataset.isChattersHqCustomer;

    // get the shipping address
    const defaultAddress = document.querySelector('[data-default-address]');
    const shippingAddress = {
      firstName: defaultAddress.querySelector('[name="address[first_name]"]').value,
      lastName: defaultAddress.querySelector('[name="address[last_name]"]').value,
      company: defaultAddress.querySelector('[name="address[company]"]').value,
      address1: defaultAddress.querySelector('[name="address[address1]"]').value,
      address2: defaultAddress.querySelector('[name="address[address2]"]').value,
      city: defaultAddress.querySelector('[name="address[city]"]').value,
      province: defaultAddress.querySelector('[name="address[province]"]').value,
      country: defaultAddress.querySelector('[name="address[country]"]').value,
      zip: defaultAddress.querySelector('[name="address[zip]"]').value,
      phone: defaultAddress.querySelector('[name="address[phone]"]').value,
    }

    const lineItems = JSON.parse(document.querySelector('[data-line-items-data]').dataset.lineItemsData);


    const orderData = {
      currency: currency,
      isChattersHQCustomer: isChattersHQCustomer,
      customer: {
        toAssociate: {
          email: customerEmail,
        }
      },
      shippingAddress: shippingAddress,
      lineItems: lineItems,
    }

    try {
      const placeOrder = await fetch('https://philocaly-chatters-api-node.vercel.app/create-order', {
        method: 'POST',
        body: JSON.stringify(orderData),
        headers: {
          'Content-Type': 'application/json',
        },
      });

      // if response is 200 then clear the cart
      if (placeOrder && placeOrder.status === 200) {

        const clearCart = await fetch('/cart/clear', {
          method: 'POST',
        });

        errorMessage.classList.add('hidden');
        thankYouForYourOrder.classList.remove('hidden');
        thankYouForYourOrder.classList.add('!block');
        cartContent.classList.add('hidden');
        placeOrderButton.classList.add('hidden');
        checkoutAddress.classList.add('hidden');

        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });

      } else {
        placeOrderChatters.disabled = false;
        errorMessage.classList.remove('hidden');
        thankYouForYourOrder.classList.add('hidden');
        setTimeout(() => {
          errorMessage.classList.add('hidden');
        }, 3000);
      }

      loaderChatters.classList.add('hidden');

    } catch (error) {
      loaderChatters.classList.add('hidden');
      errorMessage.classList.remove('hidden');
      placeOrderChatters.disabled = false;
      thankYouForYourOrder.classList.add('hidden');
      setTimeout(() => {
        errorMessage.classList.add('hidden');
      }, 3000);
    }

  };


  const updateQuantityCartInfo = async (lineItem, newQuantity) => {
    mainCartContentLoading.classList.remove('hidden');
    // const updatedCart = await changeItem({lineItemId, 0});
    const updatedCart = await changeItem({
      key: lineItem,
      quantity: newQuantity,
      mainCart: true
    });
    mainCartContentLoading.classList.add('hidden');
  };


  /**
   * Init
   */
  const init = () => {
    attachEventListener();

    document.addEventListener('main-cart:attachListener', attachEventListener);
  };

  init();
};
